export const domainMessageBasicInfo = {
    entityDetails: [],
    emailAttachments: []
};